import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTokens } from 'theme';

// The one phrase at the top of a screen: tone, a bold line, a quieter one,
// and at most one action.
const TONE = {
  ok:      { bg: 'positiveBg', dot: 'positiveFill' },
  warn:    { bg: 'warningBg',  dot: 'warningFill' },
  bad:     { bg: 'negativeBg', dot: 'negativeFill' },
  info:    { bg: 'infoBg',     dot: 'info' },
  neutral: { bg: 'raised',     dot: 'iconMuted' },
};

export default function Verdict({ tone = 'neutral', title, text, action }) {
  const t = useTokens();
  const c = TONE[tone] || TONE.neutral;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
        px: 2,
        py: 1.5,
        borderRadius: '12px',
        bgcolor: t[c.bg],
      }}
    >
      <Box
        sx={{
          width: 12,
          height: 12,
          borderRadius: '50%',
          flexShrink: 0,
          bgcolor: t[c.dot],
          boxShadow: `0 0 0 5px color-mix(in srgb, ${t[c.dot]} 22%, transparent)`,
        }}
      />
      <Box sx={{ flex: '1 1 260px', minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem' }}>{title}</Typography>
        {text && (
          <Typography sx={{ fontSize: '0.85rem', color: t.inkMuted }}>{text}</Typography>
        )}
      </Box>
      {action}
    </Box>
  );
}
